import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DEFAULT_ERROR_MESSAGE, DRAWER_KEY, FIREBASE_EVENTS, SO_TYPES } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { Button } from 'components/button'
import { BackButton } from 'components/back-button'
import { TrackingButton } from 'components/tracking-button'
import { setDrawer, setDrawerAlert, setStage } from 'slices/drawer'
import { formatDate, formatTurn } from 'utils'
import { ADDRESS_CHANGE_STAGES, BUTTON_CONTENT, BUTTON_THEME } from '../../constants'
import './style.scss'

export function RequestStatus({ data, setServiceOrderInfo }) {
  const dispatch = useDispatch()
  const { schedulingDate, turn, type, canReschedule, technician, serviceOrderInfo } = data
  const idContract = useSelector(state => state.contract.selected.id)
  const { sendEvent } = useFirebaseEvent()

  useEffect(() => {
    function loadAddressChangeStatus() {
      try {
        setServiceOrderInfo(serviceOrderInfo)
      } catch (error) {
        console.error(error)
        const errorMessage = error?.response?.data?.message || DEFAULT_ERROR_MESSAGE
        dispatch(setDrawerAlert({ severity: 'error', title: errorMessage }))
      }
    }

    loadAddressChangeStatus()
  }, [idContract, dispatch, setServiceOrderInfo, serviceOrderInfo])

  function handleClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_SERVICE_ORDER_RESCHEDULE)
    dispatch(setStage(ADDRESS_CHANGE_STAGES.RESCHEDULE))
  }

  function handleClose() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  function renderTrackingButton() {
    if (!serviceOrderInfo.displayTrackingButton) return null

    return <TrackingButton osId={serviceOrderInfo.osId} url={serviceOrderInfo.trackingUrl} />
  }

  function renderRescheduleButton() {
    if (!canReschedule) return null
    return (
      <Button
        className='order-button'
        type='button'
        color='primary'
        size='large'
        outlined
        onClick={handleClick}
      >
        {BUTTON_CONTENT[BUTTON_THEME.RESCHEDULE].TEXT}
      </Button>
    )
  }

  function renderButtons() {
    const osIsFinished = serviceOrderInfo.type === SO_TYPES.FINISHED

    if (osIsFinished) {
      return (
        <Button className='button' color='primary' size='large' onClick={handleClose}>
          Ok, entendi!
        </Button>
      )
    }

    return (
      <>
        {renderTrackingButton()}
        {renderRescheduleButton()}
        <BackButton className='back-button' />
      </>
    )
  }

  return (
    <div className='address-change-status'>
      <div className='content'>
        <h3 className='title'>Acompanhe o status da sua solicitação</h3>
        <div className='card'>
          <div className='status'>
            <span>{type}</span>
          </div>
          <span className='label'>
            Solicitação:
            <span className='text'> Mudança de Endereço</span>
          </span>
          <div className='infos'>
            <div className='order-info'>
              <span className='label'>Data de agendamento:</span>
              <span className='text'>{formatDate(schedulingDate)}</span>
            </div>
            <div className='order-shift'>
              <span className='label'>Turno:</span>
              <span className='text'>{formatTurn(turn)}</span>
            </div>
          </div>
          {technician && (
            <span className='label'>
              Técnico:
              <span className='text'> {technician}</span>
            </span>
          )}
        </div>
      </div>

      <div className='buttons'>{renderButtons()}</div>
    </div>
  )
}
